var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block__content"},[_c('v-card-actions',[_c('h4',{staticClass:"ml-5"},[_vm._v(_vm._s(_vm.name))])]),_c('v-card-text',[_c('line-chart',{ref:"chart",staticStyle:{"max-width":"100%","max-height":"700px","min-height":"400px"},attrs:{"chart-data":_vm.datacollection,"options":_vm.options,"rules":_vm.rules}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }